import React from 'react';
import { useFormikContext } from 'formik';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DynamicDropDownlist from '../../../AddNewVehicles/components/DynamicDropDownlist';
import { searchClient } from '../../../../actions/formAction';

const ShipmentClientsInfo = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext();

  const handleSecondaryClientChange = (val) => {
    const prevClients = formik.values.shipmentClients || [];
    const nextClients = val || [];
    
    // Find clients that were removed
    const removedClientIds = prevClients
      .filter(pc => !nextClients.some(nc => nc.id === pc.id))
      .map(c => c.id);
    
    if (removedClientIds.length > 0) {
      // Remove shipmentItems that contain vehicles from removed clients
      const cleared = (formik.values.containers || []).map((c) => {
        const filteredItems = (c.shipmentItems || []).filter(
          (item) => !removedClientIds.includes(item.vehicle?.client?.id)
        );
        // Recalculate net weight after removing items
        const newNetWeight = filteredItems.reduce((sum, item) => sum + (item.netWeight || 0), 0);
        return {
          ...c,
          shipmentItems: filteredItems,
          netWeight: newNetWeight,
        };
      });
      formik.setFieldValue('containers', cleared, false);
    }
    
    formik.setFieldValue('shipmentClients', nextClients, false);
  };

  return (
    <Box sx={{ }}>
   
      <DynamicDropDownlist
        label="Secondary Client"
        formik={formik}
        fieldName="shipmentClients"
        disabled={disabled}
        loadingKey="isLoadingClientData"
        dataKey="client"
        fetchAction={searchClient}
        errorKey="shipmentClients"
        dataName="name"
        dataName2="company"
        multiple
        onChange={handleSecondaryClientChange}
      />
    </Box>
  );
};

export default ShipmentClientsInfo;
